<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

  import {onMount} from 'svelte';
  import {submit} from '../Form/utils.js';
  import InlineHazardControlRow from './InlineHazardControlRow.svelte';
  import ConfirmationModal from '../ConfirmationModal.svelte';
  import Errors from '../Errors.svelte';
  import {sgettext} from '../../i18n.js';
  import {get} from '../../utils.js';

  export let id = 'inlineHazardControl';
  export let hazardOptionsApi = `${PATH_PREFIX}/sw/api/applicable-branch-hazards-controls/`;
  export let actionUrl = `${PATH_PREFIX}/sw/api/elementhazardcontrol/`;

  export let evId = 0;
  export let branchId = 0;
  export let showForm = true;
  export let deleteApi = `${PATH_PREFIX}/sw/api/kendo/element_version/{0}/element_hazard_and_control/remove/`;
  export let editable = true;

  let hazardOptions = [];

  let data = [];

  let currentRow = null;
  let promptConfirmationId = 'deleteConfirmation';
  let sending = false;
  let deleting = false;
  let deleteError = '';


  async function getHazardOptions(url) {
    try {
      const response = await get(`${url}${branchId}`);
      const json = await response.json();

      hazardOptions = json;
    } catch (err) {
      console.error(err);
    }
  }

  async function getElementHazardControl(){
     try {
      const response = await get(`${actionUrl}?ev_id=${evId}`);
      const json = await response.json();

      if(response.ok){
        data = json.results;
      } else {
        console.error(json);
      }
    } catch (err) {
      console.error(err);
    }
  }

  async function handleDelete() {
    try {
      deleting = true;
      let method = 'POST';
      let url = deleteApi.replace('{0}', currentRow.element_version);
      await submit(url, method, {id: currentRow.id});
      data = data.filter(d => d.id !== currentRow.id);
      jQuery(`#${promptConfirmationId}`).modal('hide');
    } catch(error) {
      deleteError = error;
    } finally {
      deleting = false;
    }
  }

  function cancelDelete() {
    jQuery(`#${promptConfirmationId}`).modal('hide');
  }


  onMount(async () => {
    await getHazardOptions(hazardOptionsApi);
    await getElementHazardControl();

    jQuery(`#${promptConfirmationId}`).on('hidden.bs.modal', function() {
      deleteError = null;
    });
  });


</script>

<style>

</style>

<div {id}>
  <table class:editable={editable}>
    <thead class="k-grid-header">
      <tr>
        <th>{sgettext('$$RISK$$')}</th>
        <th>{sgettext('$$CONTROL$$')}</th>
        {#if editable}
        <th>{sgettext('$$ACTIONS$$')}</th>
        {/if}
      </tr>
    </thead>
    <tbody>
      {#each data as row}
      <InlineHazardControlRow
        item={row}
        editMode={false}
        {hazardOptions}
        bind:currentRow={currentRow}
        {promptConfirmationId}
        {actionUrl}
        {editable}
      />
      {/each}
      {#if showForm}
      <InlineHazardControlRow
        {hazardOptions}
        {actionUrl}
        bind:showForm
        {evId}
        bind:data={data}
        on:completed={() => showForm = false}
      />
      {/if}
    </tbody>
  </table>
</div>


<ConfirmationModal
  id={promptConfirmationId}
  title="{sgettext('$$DELETE_CONFIRMATION$$')}"
  onYes={handleDelete}
  onNo={cancelDelete}
  sending={deleting}
>
  <div slot="message">
    <p>{sgettext('$$SURE_WANT_DELETE_FOLLOWING_RISK_CONTROL$$')}</p>
    {#if currentRow}
      <label>{sgettext('$$RISK$$')}</label>
      {#if currentRow.global_hazard && currentRow.global_hazard.name}
      <div>{currentRow.global_hazard.name}</div>
      {/if}
      {#if currentRow.global_hazard && currentRow.global_hazard.description}
      <div>{currentRow.global_hazard.description}</div>
      {/if}
      <br/>
      <label>{sgettext('$$CONTROL$$')}</label>
      {#if currentRow.global_control && currentRow.global_control.name}
      <div>{currentRow.global_control.name}</div>
      {/if}
      {#if currentRow.global_control && currentRow.global_control.description}
      <div>{currentRow.global_control.description}</div>
      {/if}
    {/if}
    <br/>
    {#if deleteError}
    <Errors errors={deleteError} />
    {/if}
  </div>
</ConfirmationModal>
